import { PackFormValues } from "../packs.types";

export enum ApiRoutesPacks {
  Packs = "admin/packs",
  AllPacks = "admin/packs/all",
  OnePack = "admin/packs/one",
  PackActive = "admin/packs/active",
  PackSlots = "slots",
  PackSlotOptions = "options"
}

export enum PackErrorCode {
  TitleAlreadyExists = "PackTitleAlreadyExistsException",
  ShortIdAlreadyExists = "PackShortIdAlreadyExistsException",
  SlotsRequired = "PackSlotsRequiredException",
  DuplicateSlotPosition = "PackDuplicateSlotPositionException",
  SlotOptionsRequired = "PackSlotOptionsRequiredException",
  OptionVariantNotFound = "PackOptionVariantNotFoundException",
  PackNotFound = "PackNotFoundException",
  PackInactive = "PackInactiveException",
  PriceBelowMinBuyingPrice = "PackPriceBelowMinBuyingPriceException"
}

export const PACKS_QUERY_KEY = "packs";
export const PACK_QUERY_KEY = "pack";

export const EMPTY_PACK_FORM_VALUES: PackFormValues = {
  title: "",
  shortId: "",
  description: "",
  media: [],
  preview: null,
  badgeId: "",
  price: null,
  merchantPrice: null,
  intermediateResellerPrice: null,
  confirmedResellerPrice: null,
  influencerPrice: null,
  recommendedSellingPrice: null,
  commission: null,
  commissionPercentage: null,
  activeCommissionType: "percentage",
  influencerCommission: null,
  influencerCommissionPercentage: null,
  activeInfluencerCommissionType: "percentage",
  discount: null,
  discountAmount: null,
  activeDiscountType: "percentage",
  allowSellingBelowBuyingPrice: false,
  isActive: true,
  isChapshopChoice: false,
  position: 0,
  slots: [
    {
      title: "",
      position: 0,
      options: []
    }
  ]
};
